module.exports = __webpack_public_path__ + "static/media/vr-cardboard.17535a5b.svg";